import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 h-16 transition-all duration-300 ${
        scrolled ? 'bg-white/90 backdrop-blur-md shadow-sm' : 'bg-[#f8fafc]'
      }`}
    >
      <div className="max-w-screen-xl mx-auto px-6 h-full flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <rect width="32" height="32" rx="8" fill="#6366f1" />
            <path d="M8 16C8 11.582 11.582 8 16 8s8 3.582 8 8-3.582 8-8 8" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
            <circle cx="16" cy="16" r="3" fill="white" />
          </svg>
          <span className="font-bold text-xl text-gray-900" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Orvexis
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-600">
          <Link to="/product" className="hover:text-gray-900 transition-colors">Product</Link>
          <Link to="/pricing" className="hover:text-gray-900 transition-colors">Pricing</Link>
          <Link to="/contact" className="hover:text-gray-900 transition-colors">Contact</Link>
        </nav>

        {/* CTA buttons */}
        <div className="hidden md:flex items-center gap-3">
          <a href="#" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors px-3 py-2">
            Sign In
          </a>
          <a
            href="#"
            className="text-sm font-semibold text-white px-5 py-2 rounded-full transition-opacity hover:opacity-80"
            style={{ backgroundColor: '#6366f1' }}
          >
            Get Started
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden p-2 rounded-md text-gray-600 hover:text-gray-900"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t px-6 py-4 flex flex-col gap-4 text-sm font-medium text-gray-700 shadow-lg">
          <Link to="/product" onClick={() => setMenuOpen(false)} className="hover:text-gray-900">Product</Link>
          <Link to="/pricing" onClick={() => setMenuOpen(false)} className="hover:text-gray-900">Pricing</Link>
          <Link to="/contact" onClick={() => setMenuOpen(false)} className="hover:text-gray-900">Contact</Link>
          <hr />
          <a href="#" className="hover:text-gray-900">Sign In</a>
          <a href="#" className="text-white text-center py-2 rounded-full font-semibold" style={{ backgroundColor: '#6366f1' }}>
            Get Started
          </a>
        </div>
      )}
    </header>
  );
}
